/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const share_android_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.746 9.891 6.508-2.531m-6.649 5.568 6.79 3.395M9 11.25a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM22.5 6A3.75 3.75 0 1 1 15 6a3.75 3.75 0 0 1 7.5 0Zm0 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
    />
  </svg>
)
export default share_android_medium
